/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Showcase_LedeInputs */

const en_features_showcase_lede = /** @type {(inputs: Features_Showcase_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your coach's plan, every set, your meals and your recovery in one place. You walk in with a plan and walk out knowing whether you got stronger.`)
};

const pl_features_showcase_lede = /** @type {(inputs: Features_Showcase_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan od trenera, każda seria, posiłki i regeneracja w jednym miejscu. Przychodzisz na trening z gotowym planem i wychodzisz z wiedzą, czy jesteś mocniejszy.`)
};

/**
* | output |
* | --- |
* | "Your coach's plan, every set, your meals and your recovery in one place. You walk in with a plan and walk out knowing whether you got stronger." |
*
* @param {Features_Showcase_LedeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_showcase_lede = /** @type {((inputs?: Features_Showcase_LedeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Showcase_LedeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_showcase_lede(inputs)
	return en_features_showcase_lede(inputs)
});